import React, { useState } from 'react';
import { Loader2, Pencil, Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';
import { accountAPI } from '../services/api';

// Admin: edit a customer's identity/contact or delete the account (orders are kept)
const CustomerEditDialog = ({ customer, onChanged }) => {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [form, setForm] = useState({ first_name: customer.first_name || '', last_name: customer.last_name || '', email: customer.email, phone: customer.phone || '', newsletter: !!customer.newsletter });
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.type === 'checkbox' ? e.target.checked : e.target.value });
  const tid = customer.email;

  const save = async () => {
    setBusy(true);
    try { await accountAPI.adminUpdateCustomer(customer.id, { ...form, phone: form.phone || null }); toast.success('Client mis à jour'); setOpen(false); onChanged(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Enregistrement impossible'); }
    finally { setBusy(false); }
  };

  const remove = async () => {
    const n = customer.orders_count || 0;
    const msg = n ? `Supprimer le compte ${customer.email} ? Ses ${n} commande(s) seront conservées mais détachées du compte. Cette action est irréversible.`
      : `Supprimer définitivement le compte ${customer.email} (panier, garage, favoris, adresses…) ?`;
    if (!window.confirm(msg)) return;
    setBusy(true);
    try { const r = await accountAPI.adminDeleteCustomer(customer.id, n > 0); toast.success(r.message); setOpen(false); onChanged(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Suppression impossible'); }
    finally { setBusy(false); }
  };

  return (
    <>
      <Button size="sm" variant="outline" disabled={busy} onClick={() => setOpen(true)} data-testid={`customer-edit-${tid}`} className="h-7 text-xs"><Pencil size={12} className="mr-1" /> Modifier</Button>
      {!customer.is_admin && <Button size="sm" variant="outline" disabled={busy} onClick={remove} data-testid={`customer-delete-${tid}`} className="h-7 text-xs text-red-600 border-red-200 hover:bg-red-50">{busy ? <Loader2 size={12} className="mr-1 animate-spin" /> : <Trash2 size={12} className="mr-1" />} Supprimer</Button>}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md" data-testid={`customer-edit-dialog-${tid}`}>
          <DialogHeader><DialogTitle>Modifier le client</DialogTitle></DialogHeader>
          <div className="grid grid-cols-2 gap-3">
            <label className="text-xs text-gray-600">Prénom<Input value={form.first_name} onChange={set('first_name')} data-testid="customer-edit-first-name" className="mt-1" /></label>
            <label className="text-xs text-gray-600">Nom<Input value={form.last_name} onChange={set('last_name')} data-testid="customer-edit-last-name" className="mt-1" /></label>
            <label className="text-xs text-gray-600 col-span-2">E-mail<Input type="email" value={form.email} onChange={set('email')} data-testid="customer-edit-email" className="mt-1" /></label>
            <label className="text-xs text-gray-600 col-span-2">Téléphone<Input value={form.phone} onChange={set('phone')} data-testid="customer-edit-phone" className="mt-1" placeholder="Optionnel" /></label>
            <label className="text-sm text-gray-700 col-span-2 flex items-center gap-2"><input type="checkbox" checked={form.newsletter} onChange={set('newsletter')} data-testid="customer-edit-newsletter" /> Inscrit à la newsletter</label>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)} data-testid="customer-edit-cancel">Annuler</Button>
            <Button onClick={save} disabled={busy || !form.first_name.trim() || !form.last_name.trim() || !form.email.trim()} data-testid="customer-edit-save" className="bg-[#1e3a5f] hover:bg-[#162c48] text-white">{busy && <Loader2 size={14} className="mr-1 animate-spin" />} Enregistrer</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CustomerEditDialog;
